<template>
  <main class="page document-page" v-if="$store.state.materials">
    <div class="document-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home' }">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'partitions' }">Деятельность</router-link>
        </li>
        <li class="breadcrumbs__item" v-if="$store.state.materials.parent && $store.state.materials.parent.parent">
          <router-link :to="{ name: 'partition', params: {id: $store.state.materials.parent.parent.id }}">{{ $store.state.materials.parent.parent.title }}</router-link>
        </li>
        <li class="breadcrumbs__item" v-if="$store.state.materials.parent">
          <router-link :to="{ name: 'partition', params: {id: $store.state.materials.parent.id }}">{{ $store.state.materials.parent.title }}</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ $store.state.materials.title }}</span>
        </li>
      </ul>
      <img :alt="$store.state.materials.name" class="news-page__image" :src="$store.state.materials | getSrc($store.state.api)"/>
      <h1 class="document-page__title">{{ $store.state.materials.title }}</h1>
      <div v-if="child_navigator && child_navigator.length" class="document-page__content">
        <nav class="point-sidebar">
          <ol class="point-sidebar-list">
            <li v-for="(link, i) in child_navigator" :key="i">
              <router-link :to="{ name: 'partition', params: { id: link.id } }" class="point-sidebar-link">{{ link.title }}</router-link>
            </li>
          </ol>
        </nav>
      </div>
      <div v-if="$store.state.materials.description" class="document-page__description" v-html="$store.state.materials.description"></div>
      <br>
      <div class="document-page__content">
        <div class="document-page__search" v-if="$store.state.materials.articles && $store.state.materials.articles.length">
          <i class="document-page__search__icon" aria-hidden="true">
            <search-icon/>
          </i>
          <input class="document-page__search__input" type="text" autocomplete="off" title="Поиск по заголовку и названию документа" placeholder="Поиск по заголовку и названию документа" v-model="search"/>
        </div>
        <div class="document-page__table" v-if="$store.state.materials.get_documents && $store.state.materials.get_documents.length">
          <div class="document-page__table__header">
            <span>Документы</span>
            <span>Дата публицации</span>
          </div>
          <ul class="document-page__table__body">
            <li class="document-page__table__item" v-for="(document, index) in $store.state.materials.get_documents" :key="index">
              <a :href="document.document | findSourceDocument($store.state.api)" download>
                <h2 style="color: brown">{{ getDocumentName(document.document.url) }}</h2>
              </a>
              <time :datetime="document.date_publication | robotDate">{{ document.date_publication | humanDate }}</time>
            </li>
          </ul>
        </div>
        <br>
        <div class="document-page__table" v-if="$store.state.materials.articles && $store.state.materials.articles.length">
          <div class="document-page__table__header">
            <span>Материалы</span>
            <span>Дата публикации</span>
          </div>
          <ul class="document-page__table__body">
            <li class="document-page__table__item" v-for="(material, index) in materials" :key="index">
              <router-link :to="{ name: 'partitionsShow', params: { id: material.id} }">
                <h2>{{ material.name }}</h2>
              </router-link>
              <time :datetime="material.updated_at | robotDate">{{ material.updated_at | humanDate }}</time>
            </li>
          </ul>
        </div>
        <span v-else class="document-page__empty">Материалы отсутствуют</span>
      </div>
    </div>
  </main>
</template>

<script>
import SearchIcon from 'components/svg/SearchIcon.vue'

export default {
  async asyncData ({ store, route }) {
    await store.dispatch('PARTITIONS_OPEN_PAGE', route.params.id)
  },
  name: 'PartitionsOpenPage',
  components: { SearchIcon },
  data () {
    return {
      search: '',
      child_navigator: this.$store.state.materials_child_navigator
    }
  },
  mounted () {
    console.log('$store.state.materials', this.$store.state.materials)
  },
  computed: {
    materials () {
      return this.$store.state.materials.articles.filter(a => !a.parent_id).filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      this.$store.state.materials.title,
      'управление образования, образование',
      '',
      this.$store.state.materials.title,
      '',
      ''
    )
  },
  methods: {
    getDocumentName (document) {
      if (document.original_name) {
        return document.original_name
      } else {
        const needle = '/partitions/documents/'
        if (document.indexOf(needle) !== -1) {
          return document.substr(document.indexOf(needle) + needle.length)
        } else {
          return document
        }
      }
    }
  }
}
</script>
